import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { gql, useMutation } from '@apollo/client'
import { Button, InputNumber, Space, message } from 'antd'

const UPDATE_LEAD_AMOUNT_PER_DAY = gql`
  mutation UpdateLeadAmountPerDay($leadAmountPerDay: Int!, $staffId: ID) {
    updateLeadAmountPerDay(leadAmountPerDay: $leadAmountPerDay, staffId: $staffId) {
      leadAmountPerDay
      saved {
        id
      }
      errors {
        key
        message
      }
    }
  }
`

const CapacityForm = ({ initialValue, label, onSaved, staffId }) => {
  const { i18n } = useTranslation('leadDistributions')
  const [value, setValue] = useState(initialValue)

  const [updateLeadAmountPerDay, { loading }] = useMutation(UPDATE_LEAD_AMOUNT_PER_DAY, {
    onCompleted: ({ updateLeadAmountPerDay: result }) => {
      if (result && result.saved) {
        message.success(i18n.t('leadDistributions:capacity.saved', { value: result.leadAmountPerDay }))
        if (onSaved) onSaved()
        return
      }

      const errors = (result && result.errors) || []
      message.error(errors.map(error => error.message).join(', ') || i18n.t('leadDistributions:capacity.failed'))
    },
    onError: (error) => {
      message.error(error.message || i18n.t('leadDistributions:capacity.failed'))
    }
  })

  const onSubmit = () => {
    if (value === null || value === undefined) return

    updateLeadAmountPerDay({
      variables: { leadAmountPerDay: value, staffId: staffId || null }
    })
  }

  return (
    <Space wrap>
      <span>{label}</span>
      <InputNumber
        min={0}
        onChange={setValue}
        onPressEnter={onSubmit}
        placeholder={i18n.t('leadDistributions:capacity.placeholder')}
        precision={0}
        value={value}
      />
      <Button disabled={value === null || value === undefined} loading={loading} onClick={onSubmit} type="primary">
        {i18n.t('leadDistributions:capacity.submit')}
      </Button>
    </Space>
  )
}

CapacityForm.propTypes = {
  initialValue: PropTypes.number,
  label: PropTypes.string.isRequired,
  onSaved: PropTypes.func,
  staffId: PropTypes.string
}

CapacityForm.defaultProps = {
  initialValue: null,
  onSaved: null,
  staffId: null
}

export default CapacityForm
